import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GridOptions } from "ag-grid-community";
import { DetailRow } from "./recurring-detector.service";
import { getDetailColumns } from "./recurring-detector-columns";

export interface RecurringDetectorDetailDialogData {
  title: string;
  rows: DetailRow[];
}

@Component({
  selector: "app-recurring-detector-detail-dialog",
  template: `
    <div class="tw-flex tw-items-center tw-justify-between tw-p-4 border-bottom-gray">
      <span class="tw-text-sm tw-font-semibold">{{ data.title }}</span>
      <close-button [type]="'plain'"></close-button>
    </div>
    <div class="tw-flex-1 tw-overflow-auto tw-p-4">
      <app-ag-grid-table
        [options]="gridOptions"
        [data]="data.rows"
        [hasHeader]="true"
      ></app-ag-grid-table>
    </div>
  `,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        width: 600px;
        max-width: 100%;
        max-height: 80vh;
        overflow: hidden;
      }
    `,
  ],
})
export class RecurringDetectorDetailDialogComponent {
  protected data = inject<RecurringDetectorDetailDialogData>(MAT_DIALOG_DATA);
  protected gridOptions: GridOptions<DetailRow> = { columnDefs: getDetailColumns() };
}
